var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.open
      ? _c("div", {
          staticClass: "nav-overlay fixed z-10 pin bg-black transition-slow",
          on: { click: _vm.close }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28c4cfac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c4cfac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/Overlay.vue
// module id = 401
// module chunks = 0